/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { PutCall } from './PutCall';
import {
    PutCallFromJSON,
    PutCallFromJSONTyped,
    PutCallToJSON,
} from './PutCall';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface OpenLot
 */
export interface OpenLot {
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    description?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof OpenLot
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof OpenLot
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof OpenLot
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    referencePortfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    allocationType?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    investmentAlgo: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    investmentSleeve: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    costBasis: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    nav: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    coId?: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    mic?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    settlementMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    minTick?: number;
    /**
     * 
     * @type {PutCall}
     * @memberof OpenLot
     */
    putCall?: PutCall;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    underlyingSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    openLotId: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    closePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    marketValue: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    pnlUnrealized: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    returnUnrealized?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    pnlUnrealizedType?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLot
     */
    openDate: string;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    marketValuePercentOfNav?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    netExposure: number;
    /**
     * 
     * @type {number}
     * @memberof OpenLot
     */
    grossExposure: number;
}



/**
 * Check if a given object implements the OpenLot interface.
 */
export function instanceOfOpenLot(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "investmentAlgo" in value;
    isInstance = isInstance && "investmentSleeve" in value;
    isInstance = isInstance && "costBasis" in value;
    isInstance = isInstance && "nav" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "openLotId" in value;
    isInstance = isInstance && "marketValue" in value;
    isInstance = isInstance && "pnlUnrealized" in value;
    isInstance = isInstance && "openDate" in value;
    isInstance = isInstance && "netExposure" in value;
    isInstance = isInstance && "grossExposure" in value;

    return isInstance;
}

export function OpenLotFromJSON(json: any): OpenLot {
    return OpenLotFromJSONTyped(json, false);
}

export function OpenLotFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenLot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'aC': json['a_c'],
        'sId': json['s_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'quantity': json['quantity'],
        'side': json['side'],
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : json['allocation_type'],
        'investmentAlgo': json['investment_algo'],
        'investmentSleeve': json['investment_sleeve'],
        'costBasis': json['cost_basis'],
        'nav': json['nav'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'putCall': !exists(json, 'put_call') ? undefined : PutCallFromJSON(json['put_call']),
        'underlyingSymbol': !exists(json, 'underlying_symbol') ? undefined : json['underlying_symbol'],
        'brokerId': json['broker_id'],
        'openLotId': json['open_lot_id'],
        'closePrice': !exists(json, 'close_price') ? undefined : json['close_price'],
        'marketValue': json['market_value'],
        'pnlUnrealized': json['pnl_unrealized'],
        'returnUnrealized': !exists(json, 'return_unrealized') ? undefined : json['return_unrealized'],
        'pnlUnrealizedType': !exists(json, 'pnl_unrealized_type') ? undefined : json['pnl_unrealized_type'],
        'openDate': json['open_date'],
        'marketValuePercentOfNav': !exists(json, 'market_value_percent_of_nav') ? undefined : json['market_value_percent_of_nav'],
        'netExposure': json['net_exposure'],
        'grossExposure': json['gross_exposure'],
    };
}

export function OpenLotToJSON(value?: OpenLot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'a_c': value.aC,
        's_id': value.sId,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'quantity': value.quantity,
        'side': value.side,
        'reference_portfolio': value.referencePortfolio,
        'allocation_type': value.allocationType,
        'investment_algo': value.investmentAlgo,
        'investment_sleeve': value.investmentSleeve,
        'cost_basis': value.costBasis,
        'nav': value.nav,
        'sc_id': value.scId,
        'co_id': value.coId,
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
        'symbol': value.symbol,
        'primary_exchange': value.primaryExchange,
        'cusip': value.cusip,
        'isin': value.isin,
        'sedol': value.sedol,
        'country': value.country,
        'mic': value.mic,
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'issuer': value.issuer,
        'coupon': value.coupon,
        'maturity_date': value.maturityDate,
        'issue_date': value.issueDate,
        'expiration_date': value.expirationDate,
        'first_notice_date': value.firstNoticeDate,
        'settlement_method': value.settlementMethod,
        'min_tick': value.minTick,
        'put_call': PutCallToJSON(value.putCall),
        'underlying_symbol': value.underlyingSymbol,
        'broker_id': value.brokerId,
        'open_lot_id': value.openLotId,
        'close_price': value.closePrice,
        'market_value': value.marketValue,
        'pnl_unrealized': value.pnlUnrealized,
        'return_unrealized': value.returnUnrealized,
        'pnl_unrealized_type': value.pnlUnrealizedType,
        'open_date': value.openDate,
        'market_value_percent_of_nav': value.marketValuePercentOfNav,
        'net_exposure': value.netExposure,
        'gross_exposure': value.grossExposure,
    };
}

